export default __webpack_public_path__ + "static/studioupdate-dddc43efc100d9eaaa529f32eacc0d5d.svg";